import { render } from "./DemoFirst.vue?vue&type=template&id=7132986e"
import script from "./DemoFirst.vue?vue&type=script&lang=js"
export * from "./DemoFirst.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Demo/DemoFirst.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7132986e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7132986e', __exports__)) {
    console.log('reload')
    api.reload('7132986e', __exports__)
  }
  
  module.hot.accept("./DemoFirst.vue?vue&type=template&id=7132986e", () => {
    console.log('re-render')
    api.rerender('7132986e', render)
  })

}


export default __exports__